import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export const initialize = createAction(`${actionTypePrefix}/INITIALIZE`, ()=>({}));
export const requestSuccess = createAction(`${actionTypePrefix}/REQUEST_SUCCESS`, (data)=>({
        data
    }));
export const requestFailure = createAction(`${actionTypePrefix}/REQUEST_FAILURE`, ()=>({}));

//# sourceMappingURL=actionCreators.js.map